import Debug from 'debug'
import User from './User.js'

const debug = Debug('cbio.users')

export default (api) => ({

  get: async (id, query, options) => {
    debug('get()', id, query)
    return new User(api, await api.fetch(User.url({ id }), query, options))
  },

  current: async (query, options) => {
    debug('current()')
    return new User(api, await api.fetch(User.url({ id: 'me' }), query, options))
  }

})

export { User }
